export default {
      id: "svg-icon-ico-instagram-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "static/images/svg-icons.svg#svg-icon-ico-instagram",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-svg/ico-instagram.svg
// module id = C6cs
// module chunks = 4